import {
  Paper,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material'
import { styled } from '@mui/material/styles'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { useLoadingStore } from 'stores/loading.store'
import { BlogStat } from '../../types/blog'

const regex = /(?:\s-\s|\s%\s)MarketEnterprise\sVietnam/i

const fetchGA4Stats = async () => {
  const res = await axios.get<BlogStat[]>(`${process.env.REACT_APP_BACKEND_API_URL}/auth/get-blog`)
  return res.data
}

const BlogDashboard = () => {
  const [postData, setPostData] = useState<BlogStat[]>([])
  const setIsGlobalLoading = useLoadingStore((state) => state.setIsGlobalLoading)

  useEffect(() => {
    setIsGlobalLoading(true)
    fetchGA4Stats()
      .then((data) => {
        setIsGlobalLoading(false)
        if (data.length > 0) {
          data.sort((a, b) => b.total_page_views - a.total_page_views)
          setPostData(data)
        }
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        setIsGlobalLoading(false)
      })
  }, [])

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    '&:first-of-type': {
      borderBottomLeftRadius: 0,
      boxShadow: 'none'
    },
    '&:last-of-type': {
      borderBottomRightRadius: 0,
      boxShadow: 'none'
    },
    '&:first-of-type  th': {
      borderBottomLeftRadius: 0
    },
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#00AB55',
      color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14
    }
  }))

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0
    }
  }))

  return (
    <TableContainer component={Paper} className="rounded-none">
      <Table sx={{ minWidth: 700 }}>
        <TableHead>
          <TableRow>
            <StyledTableCell sx={{ paddingLeft: 0 }}>Title</StyledTableCell>
            <StyledTableCell>Author</StyledTableCell>
            <StyledTableCell align="center">Page Views</StyledTableCell>
            <StyledTableCell align="center">Average time</StyledTableCell>
            <StyledTableCell align="right">Traffics</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {postData.map((row) => (
            <StyledTableRow key={row.title.replace(regex, '')}>
              <StyledTableCell component="th" scope="row">
                {row.title.replace(regex, '')}
              </StyledTableCell>
              <StyledTableCell>{row.authorName}</StyledTableCell>
              <StyledTableCell align="center">{row.total_page_views}</StyledTableCell>
              <StyledTableCell align="center">{row.avgTimeOnPage}</StyledTableCell>
              <StyledTableCell align="right">{`Organic: ${row.source.organic_search} - Social: ${row.source.organic_social} - Direct: ${row.source.direct}`}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default BlogDashboard
